namespace Areas.Employee.TimeEntryRights {
    "use strict";

    export function newTimeEntryRight(e) {
        e.data.employeeId = $("#TimeEntryRightsGrid").dxDataGrid("instance").option("EmployeeId");
    }

}